import { MX_STAGES, Stage, US_STAGES } from "../helpers/get-settings";
import React from "react";
import { StatusEnum } from "../hoc/with-status";

export interface PopoverProps {
  title: string;
  body?: string[];
  buttonText?: string;
}

interface TaskWithStatus {
  (status: StatusEnum, isExpanded?: boolean, taskId?: string): React.ReactNode;
}

export interface Task {
  titleText: string;
  details: React.ReactNode | TaskWithStatus;
  buttonText?: string;
  href?: string | Record<Stage, string>;
  isLink?: boolean;
  analyticsOnAction?: string;
  analyticsOnExpand?: string;
  /**
   * The path where task status information can retrieved.
   */
  titleStatusPath?: string;
  subtasks?: Task[];
  errorStatusDetailMessage?: React.ReactNode;
  statusDetailMessage?: Record<StatusEnum | string, React.ReactNode>;
  hideWhenError?: boolean;
  isFallback?: boolean;
  expandWhenNotStarted?: boolean;
  popover?: PopoverProps;
  disableWhenCompleted?: boolean;
  shouldOverrideStatus?: Record<string, StatusEnum>;
  hideInProd?: boolean;
  hideOnConfig?: boolean;
  taskStatusName?: string;
  hideOnTaskStatusError?: boolean;
  getTaskStatusByBBId?: boolean;
  checkBusinessLine?: boolean;
  taskName?: string;
}

export interface TaskGroup {
  name: string;
  tasks: Array<Task>;
}

const US_TASKS_LIST = [
  "Pack I-9 documents for your appointment",
  "Complete your I-9 Employment Authorization Form",
  "Watch the new hire video",
  "Take your badge photo",
  "Complete pre-employment screening",
  "Provide personal information",
  "Order your safety shoes",
  "Complete employment paperwork",
  "Complete new hire orientation",
  "Set up A to Z Account",
];

const MX_TASKS_LIST = [
  "Upload work authorization documents",
  //  "Watch the new hire video", //TODO: Uncomment if enhance with "MX new hire video"
  "Take your badge photo",
  "Complete pre-employment screening",
  "Complete employment paperwork",
  "Complete new hire orientation",
  "Set up A to Z Account",
];

const US_SUBTASKS_LIST = ["BGC", "AIR BGC", "Drug Test"];

const MX_SUBTASKS_LIST = ["BGC", "Drug Test", "Medical Check"];

export function isTaskEnabled(
  taskName: string,
  taskType: string,
  stage: string
) {
  if (!stage) {
    return false;
  }

  if (
    (taskType === "TASK" &&
      ((US_STAGES.includes(stage as Stage) &&
        !US_TASKS_LIST.includes(taskName as string)) ||
        (MX_STAGES.includes(stage as Stage) &&
          !MX_TASKS_LIST.includes(taskName as string)))) ||
    (taskType === "SUBTASK" &&
      ((US_STAGES.includes(stage as Stage) &&
        !US_SUBTASKS_LIST.includes(taskName as string)) ||
        (MX_STAGES.includes(stage as Stage) &&
          !MX_SUBTASKS_LIST.includes(taskName as string))))
  ) {
    return false;
  }
  return true;
}
